import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyATYD4sbw_RAToyBYgY6rwDdPs-KROKmS4',
    libraries: 'places'
  }
})



// WEBPACK FOOTER //
// ./src/plugins/google-map.js